import styled from "styled-components";

export const StyledFooter = styled.footer`



	margin-top: auto;

	padding: 10px 0;

	border-top: 1px solid #D3D3D3;

	p {
		text-align: center;
	}



`